import * as Popover from "@radix-ui/react-popover";
import { Link } from "lucide-react";
import { Icon } from "../../features/ui/Icon.js";
import { Toolbar } from "../../features/ui/Toolbar.js";
import i18next from "i18next";
import { LinkPreviewEditorPanel } from "./LinkPreviewEditorPanel.js";

export type EditIframeLinkPopoverProps = {
  onSetLink: (src: string) => void;
  initialSrcLink: string;
};

export const EditLinkPreviewPopover = ({
  onSetLink,
  initialSrcLink,
}: EditIframeLinkPopoverProps) => {
  return (
    <Popover.Root>
      <Popover.Trigger asChild>
        <Toolbar.Button
          type="button"
          tooltip={
            i18next.t("setEmbedCodeOrLink") || "Set Embed Code / Embed Link"
          }
        >
          <Icon icon={Link} />
        </Toolbar.Button>
      </Popover.Trigger>
      <Popover.Content>
        <LinkPreviewEditorPanel
          onSetLink={onSetLink}
          initialSrc={initialSrcLink ?? ""}
        />
      </Popover.Content>
    </Popover.Root>
  );
};
